// extracted by mini-css-extract-plugin
module.exports = {"loginList":"Register_loginList__LAmxN","facebook":"Register_facebook__1B0Pv","google":"Register_google__3JM_u"};